import _implicitStylesheets from "./messageBoxCard.css";
import _implicitScopedStylesheets from "./messageBoxCard.scoped.css?scoped=true";
import _c360Icon from "c360/icon";
import _pageLink from "page/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="slds-col message-text${0}"${2}><span${3}>${"t2"}</span></div>`;
const $fragment2 = parseFragment`<a${"a0:href"} class="message-link${0}"${"a0:title"}${"a0:target"}${2}><span class="slds-truncate${0}"${"a1:title"}${2}>${"t2"}</span></a>`;
const stc0 = {
  classMap: {
    "slds-grid": true,
    "slds-grid_vertical": true
  },
  key: 3
};
const stc1 = {
  classMap: {
    "slds-col": true
  },
  key: 6
};
const stc2 = {
  key: 7
};
const stc3 = {
  key: 10
};
const stc4 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, s: api_slot} = $api;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.cssClass),
    key: 0
  }, [!$cmp.withoutIcon ? api_element("span", {
    className: api_normalize_class_name($cmp.iconClass),
    key: 1
  }, [api_custom_element("c360-icon", _c360Icon, {
    props: {
      "iconName": $cmp.iconName,
      "iconDescription": $cmp.type,
      "size": "x-small"
    },
    key: 2
  })]) : null, api_element("div", stc0, [api_static_fragment($fragment1, 5, [api_static_part(2, null, api_dynamic_text($cmp.message))]), $cmp.action ? api_element("div", stc1, [api_custom_element("page-link", _pageLink, stc2, [api_static_fragment($fragment2, 9, [api_static_part(0, {
    attrs: {
      "href": $cmp.action.href,
      "title": $cmp.action.name,
      "target": $cmp.action.target
    }
  }, null), api_static_part(1, {
    attrs: {
      "title": $cmp.action.name
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.action.name))])])]) : null, api_slot("", stc3, stc4, $slotset)])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = [""];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-572tmg8m4gs";
tmpl.legacyStylesheetToken = "appx-messageBox_messageBoxCard";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
